import styled from "@emotion/styled";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { createFocusRingStyles } from "../../../util/createFocusRingStyles";
import { ChipProps } from "../components/Chip";
import { chipCustomCssProperties } from "./chipConstants";
import { chipTheme } from "./chipTheme";

export interface ChipCloseButtonProps {
    isReadonly: boolean;
    size: Exclude<ChipProps["size"], undefined>;
    themeMode: RequiredThemeKeys;
}

export const ChipRemoveButton = styled("div")<ChipCloseButtonProps>(
    ({ themeMode, size, isReadonly }) => `
    &:focus {
        ${chipCustomCssProperties.removeButtonOpacity}: 1.0;
    }
    margin: 0;
    padding: 0;
    border: none;
    // This is necessary to prevent the button from overflowing the Ursa AvatarChip containers
    border-radius: var(
        --sds--chip--border-radius,
        ${`calc(${chipTheme.borderRadius(themeMode)} * 2)`}
    );
    padding-left: var(--sds--chip--close--padding-left, 0);

    position: absolute;
    right: var(--sds--chip--close--right, 3px);

    // allow 2px above and below.
    height: calc(100% - 6px);
    width: var(--sds--chip--close--size, calc(${chipTheme.height[size](themeMode)} - 6px));
    --sds--ursa-icons--size: var(--sds--chip--close--size);

    color: inherit;

    // This doesn't do anything in Chrome because it's dealt with in the user-agent-stylesheet
    // But in every other browser it's necessary to vertically center the button.
    display: inline-flex;
    align-items: center;
    justify-content: center;

    cursor: ${isReadonly ? "auto" : "pointer"};

    // Only show on hover.
    opacity: var(${chipCustomCssProperties.removeButtonOpacity}, 0);

    background-color: var(${chipCustomCssProperties.backgroundHover});
    &:active {
        background-color: var(${chipCustomCssProperties.backgroundActive});
    }

    transition: ${chipTheme.motion.animation(themeMode)};

    ${createFocusRingStyles({
        theme: "ursa-light",
        gap: -1,
        componentBorderWidth: 0,
        componentRadius: `calc(${chipTheme.borderRadius(themeMode)} * 2)`,
        position: "absolute",
        focusSelector: ":focus-visible",
        innerColorOverride: "transparent",
    })}
`
);
